import React from 'react';
import { X as Icon } from 'react-bootstrap-icons';
import { useController } from './provider';
import Button from 'react-bootstrap/Button';

export const CancelButton = () => {
    const { hideEditor, isEditing } = useController();
    return !isEditing ? null : (
        <Button variant="outline-secondary" onClick={hideEditor}><Icon /></Button>
    );
};
